import { useApiPatch } from 'mf_core/query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useMarkAsReadNotifications(toDate?: string) {
  const queryClient = useQueryClient();
  const apiPatch = useApiPatch();

  type MarkAsReadNotificationRequestTo = {
    notificationIds: string[];
    notificationStatus: 'read' | 'delete' | 'delivered';
    subscriberId: string | null;
  };

  return useMutation({
    mutationFn: async (body: MarkAsReadNotificationRequestTo) => {
      return await apiPatch(
        '/account-management/v1/notifications/status',
        body
      );
    },
    onError: () => {
      // optional error handler
    },
    onSuccess: async () => {
      const toDateParam = toDate ? `&ToDate=${encodeURIComponent(toDate)}` : '';

      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [
            `/account-management/v1/notifications/history?NotificationType=inapp&onlySummary=true&ReadStatus=unread${toDateParam}`,
          ],
        }),
        queryClient.invalidateQueries({
          queryKey: [
            `/account-management/v1/notifications/history?NotificationType=inapp&onlySummary=true&ReadStatus=all${toDateParam}`,
          ],
        }),
      ]);

      await queryClient.invalidateQueries({
        queryKey: [
          '/account-management/v1/notifications/unread-count?NotificationType=inapp&ReadStatus=unread',
        ],
      });
    },
  });
}
